import { naturalCatalysts, synthesizedCatalysts } from '../../data/catalysts';
import { bases as BASES } from '../../data/bases';
import { ItemLink } from '../item';

const CATALYSTS = {
	...naturalCatalysts,
	...synthesizedCatalysts
};

const ProductInfo = ({ product, onAddCatalystToBasket, onAddSpecificMainToBasker }) => {
	return (
		<div className="product__info">
			<div className="product__info--list-wrapper grid grid-xs-2">
				<ul className="product__info--list">
					<li>Type: {product.type}</li>
					<li>Element: <strong className={`ele-box--inline ${product.element.toLowerCase()}`}>{product.element}</strong></li>
					<li>---</li>
					<li>Min. Quality: {product.minQuality > 0 ? <strong>{product.minQuality}</strong> : 0}</li>
					<li>Min. Score: {product.minScore > 0 ? <strong>{product.minScore}</strong> : 0}</li>
				</ul>
				<ul className="product__info--list">
					<li>Base:<br />{BASES[product.base]?.id ? <ItemLink item={BASES[product.base]} /> : product.base}</li>
					<li>
						Catalyst:<br />
						{
							CATALYSTS[product.catalyst]?.id ?
								<>
									<ItemLink item={CATALYSTS[product.catalyst]} />
									{CATALYSTS[product.catalyst]?.isCraftable && (
										<button
											className="add-to-basket"
											onClick={() => onAddCatalystToBasket(CATALYSTS[product.catalyst]?.id)}
										>
											<img
												src={'./assets/icon--plus.svg'}
												alt={'Add to basket'}
												title={'Add to basket'}
												className={'icon'}
											/>
										</button>
									)}
								</> :
									product.catalyst
						}
					</li>
					<li>
						Specific Main:<br />
						{
							product.specificMain?.id ?
								<>
									<ItemLink item={product.specificMain} />
									<button
										className="add-to-basket"
										onClick={() => onAddSpecificMainToBasker(product.specificMain?.id)}
									>
										<img
											src={'./assets/icon--plus.svg'}
											alt={'Add to basket'}
											title={'Add to basket'}
											className={'icon'}
										/>
									</button>
								</> :
									product.specificMain
						}
					</li>
				</ul>
			</div>
		</div>
	);
};

export default ProductInfo;

